import React, { useEffect, useState } from "react";
import { Edit, SimpleForm, TextInput, required, TopToolbar, Button, useRedirect, DateInput, AutocompleteInput, RadioButtonGroupInput, useGetOne, useNotify, FileInput, FileField, SelectInput } from "react-admin";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { getNameAndCompanyNamewithAddress, invoiceChoices } from "../common";

const InvoiceHistoryEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const { id } = useParams(); 
  const [isPay,setIsPay] = useState(false);
  const [customers,setCustomers]=useState([]);
  const { data, isLoading } = useGetOne("invoiceHistory", { id });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  useEffect(()=>{
    if(!isLoading){
      setIsPay(data.isPay);
    }
  },[isLoading])

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, marginBottom:-2 }}>
        <TopToolbar>
            <Button
                label="請求書を作成"
                onClick={() => redirect(`/invoice-form/invoiceHistory/${id}`)}
                startIcon={<NoteAddIcon />}
            />
            <Button
                label="請求詳細表示"
                onClick={() => redirect(`/invoiceHistory/show/${id}`)}
                startIcon={<VisibilityIcon />}
            />
        </TopToolbar>
    </Box>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Edit mutationMode="pessimistic"
        mutationOptions={{ 
          onSuccess: () => {
            notify('更新が完了しました', { type: 'success' }); 
            // redirect('list', 'invoiceHistory');
            window.history.back();
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <AutocompleteInput
              source="customerId"
              label="顧客名"
              choices={customers.map(req => ({
                id: req.id, 
                name: `${getNameAndCompanyNamewithAddress(req)}`
              }))}
              validate={required()}
              allowEmpty
              freeSolo  
              style={{marginRight:"10px"}}
            />
            <SelectInput
              source="invoiceCategory"
              label="請求対象区分"
              choices={invoiceChoices}
              style={{marginLeft:"10px"}}
            />
          </div>
        <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <DateInput source="invoiceDate" label="請求日" style={{marginRight:"10px"}} inputProps={{ max: '9999-12-31' }}/>
          <TextInput source="invoiceAmount" label="請求金額(税抜き)" style={{marginLeft:"10px",marginRight:"10px"}}/>
          <SelectInput source="payMethod" label="支払い方法" choices={[
                { id: "持参", name: "持参" },
                { id: "振り込み", name: "振り込み" },
                { id: "集金", name: "集金" }
              ]} style={{marginLeft:"10px"}}/>
        </div>
        <DateInput source="reissueDate" label="再発行日" inputProps={{ max: '9999-12-31' }}/>
        <RadioButtonGroupInput
          source="isPay"
          label="領収"
          choices={[
            { id: 1, name: '領収済み' },
            { id: 0, name: '未領収' }
          ]}
          validate={required()}
          defaultValue={isPay}
          onChange={(e) => setIsPay(Number(e.target.value))}
        />
        <DateInput source="receiptDate" label="領収日" disabled={!isPay} inputProps={{ max: '9999-12-31' }}/>
        <FileInput source="documentURL" label="請求書" accept="application/pdf, image/*">
          <FileField source="src" title="title" />
        </FileInput>
        </SimpleForm>
      </Edit>
    </>
  )

};

export default InvoiceHistoryEdit;
